import { CategorySVG, FireSVG } from "../../../../../assets";
import { BulletList } from "../BulletList";

interface Props {
  data: any;
}

export const FundamentalAnalysis = ({ data }: Props) => {
  if (!data) return <></>;
  return (
    <div className="w-full">
      <div className="mb-6 leading-[24px]">{data.shortDescription}</div>
      <div className="flex gap-3 flex-col sm:flex-row mb-4">
        <BulletList
          title="Project Category Strength"
          premium
          icon={<CategorySVG />}
          list={data.details.projectCategoryStrength.items.map((item) => ({
            text: item,
          }))}
          score={data.details.projectCategoryStrength.score}
        />
        <BulletList
          title="Usage & Adoption Metrics"
          premium
          icon={<CategorySVG />}
          list={data.details.usageAndAdoptionMetrics.items.map((item) => ({
            text: item,
          }))}
          score={data.details.usageAndAdoptionMetrics.score}
        />
      </div>
      <div className="flex gap-3 flex-col sm:flex-row">
        <BulletList
          title="Narrative alignment"
          premium
          icon={<FireSVG />}
          list={data.details.narrativeAlignment.items.map((item) => ({
            text: item,
          }))}
          score={data.details.narrativeAlignment.score}
        />
        <BulletList
          title="Market presence"
          premium
          icon={<FireSVG />}
          list={data.details.marketPresence.items.map((item) => ({
            text: item,
          }))}
          score={data.details.marketPresence.score}
        />
      </div>
    </div>
  );
};
